module.exports = __webpack_public_path__ + "img/img1.f79e1d9e.jpg";